import { createVerticalSmallHeadingAndTextStyles } from "@guestsupply/App/SharedStyles/smallHeadingAndTextStyles";
import { shippingInfoStyles } from "@guestsupply/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitShippingInfo";
import { orderInformationStyles } from "@guestsupply/Overrides/Widgets/OrderConfirmation/OrderConfirmationOrderInformation";
import { color, mergeWithCss, xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

orderInformationStyles.OrderInformationGridContainer = {
    gap: 24,
};

orderInformationStyles.orderDetailsGridContainer = {
    gap: 22,
    css: css`
        border-bottom: 1px solid ${color("common.ui3")};
        padding-bottom: 24px;
    `,
    offsetCss: css`
        ${xScreen("lte", "xs")} {
            flex-direction: column;
        }
    `,
};

orderInformationStyles.orderNumberGridItem = {
    width: 12,
    css: css`
        padding-bottom: 8px !important;
    `,
};
orderInformationStyles.orderInformationGridItems = {
    width: [12, 6, 6, 4, 4],
    css: css`
        @media print {
            padding: 5px !important;
        }
    `,
};
orderInformationStyles.statusGridItem = {
    width: [12, 6, 6, 4, 4],
};
orderInformationStyles.orderDateGridItem = {
    width: [12, 6, 6, 4, 4],
};
orderInformationStyles.poNumberGridItem = {
    width: [12, 6, 6, 4, 4],
};
orderInformationStyles.salespersonGridItem = {
    width: [12, 6, 6, 4, 4],
};
orderInformationStyles.dueDateGridItem = {
    width: [12, 6, 6, 4, 4],
};
orderInformationStyles.addressSection = {
    ...mergeWithCss(shippingInfoStyles?.addressSection, {
        css: css`
            max-width: unset;
        `,
    }),
};
orderInformationStyles.addressTitle = {
    ...shippingInfoStyles?.addressTitle,
};

orderInformationStyles.headingAndTextStyles = {
    ...createVerticalSmallHeadingAndTextStyles({
        wrapper: {
            css: css`
                gap: 8px;
            `,
        },
        heading: {
            size: 16,
            weight: "bold",
            css: css`
                letter-spacing: 0;
                line-height: 17px;
            `,
        },
        text: {
            size: 13,
            css: css`
                letter-spacing: 0;
                line-height: 20px;
            `,
        },
    }),
};
orderInformationStyles.addressDescription = {
    size: 14,
    lineHeight: "21px",
};
orderInformationStyles.vatNumberText = {
    size: 14,
};
